import { render } from "./NegativeAreaChart.vue?vue&type=template&id=2cf4512a&ts=true"
import script from "./NegativeAreaChart.vue?vue&type=script&lang=ts"
export * from "./NegativeAreaChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__